__turbopack_context__.v({
  "head": "MobileComponent-module__eVGs4W__head",
  "items": "MobileComponent-module__eVGs4W__items",
  "root": "MobileComponent-module__eVGs4W__root",
  "sleepItemsContainer": "MobileComponent-module__eVGs4W__sleepItemsContainer",
});
